import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class Affiliate extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/profile/getaffiliate", {})
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">
                            <div className="nk-block nk-block-lg">
                                <div className="card card-bordered">
                                    <div className="card-inner">
                                        <div className="alert alert-fill alert-info alert-icon">
                                            <em className="icon ni ni-alert-circle"></em> شما میتوانید به وسیله کدهای تعریف شده در جدول زیر، در فروش های ما سهیم شوید
                                            <br />
                                        </div>

                                        <h5 className="mt-4 mb-2">فهرست پلن های همکاری در فروش شما</h5>
                                        {this.isEmpty(this.state.data.records) ?
                                            <div className="card-inner-group">
                                                <div className="example-alert">
                                                    <div className="alert alert-pro alert-warning">
                                                        <div className="alert-text">
                                                            <h6>توجه</h6>
                                                            <p>در حال حاضر هیچ پلنی برای شما ثبت نشده است</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div className="card-inner-group">
                                                <div className="card-inner p-0">
                                                    <div className="nk-tb-list nk-tb-ulist">
                                                        <div className="nk-tb-item nk-tb-head">
                                                            <div className="nk-tb-col"><span className="sub-text">عنوان پلن</span></div>
                                                            <div className="nk-tb-col"><span className="sub-text">وضعیت</span></div>
                                                            <div className="nk-tb-col"><span className="sub-text">توضیحات</span></div>
                                                            <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">کد</span></div>
                                                        </div>
                                                        {this.state.data.records.map((record, index) =>
                                                            <div className="nk-tb-item">
                                                                <div className="nk-tb-col">
                                                                    <span className="sub-text">{record.title}</span>
                                                                </div>
                                                                <div className="nk-tb-col">
                                                                    <span className="sub-text">{record.statusString}</span>
                                                                </div>
                                                                <div className="nk-tb-col">
                                                                    <span className="sub-text">{record.description}</span>
                                                                </div>
                                                                <div className="nk-tb-col tb-col-md">
                                                                    <span className="sub-text text-center ltr">{record.code}</span>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,

                <Footer />
            ];

        return contents;
    }
}